//import * as Sentry from '@sentry/browser';
//import { Integrations } from "@sentry/tracing";


//Sentry.init({
//    dsn: 'https://05ad3fe044a6493fbda3334d5a945b85@o215445.ingest.sentry.io/5503847',
    /*integrations: [
        new Integrations.BrowserTracing(),
    ],*/

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
//    tracesSampleRate: 1.0,
//    debug: false
//});




export class RetailRocket
{
    track(callback)
    {
        (window["rrApiOnReady"] = window["rrApiOnReady"] || []).push(function() {
            try{
                callback();
            } catch(e) {
                if (isDevelopment) {
                    console.log(e);
                }
            }
        });
    }

    viewContentProduct(product)
    {
        let callback;
        if (product.is_offers) {
            callback = function() {
                rrApi.groupView(product.offers_id);
            };
        } else {
            callback = function() {
                rrApi.view(product.id);
            };
        }

        this.track(callback);
    }

    /**
     * @param categoryCode
     * @returns {boolean}
     */
    static isCategorySendTrack(categoryCode)
    {
        let excludeCategoriesCode = [
            'podarki',
            'podarki-bossu',
            'podarki-dlya-muzhchin',
            'dlya-kolleg',
            'dlya-podrug',
            'dlya-mamy',
            'dlya-lyubimoy',
            'rasprodazha',
            'povrezhdennaya-upakovka'
        ];

        return (excludeCategoriesCode.indexOf(categoryCode) === -1);
    }

    viewContentCategory(category)
    {
        if (RetailRocket.isCategorySendTrack(category.code)) {
            this.track(function() {
                rrApi.categoryView(category.id);
            });
        }
    }

    subscription(email)
    {
        this.track(function() {
            rrApi.setEmail(email);
            rrApi.welcomeSequence(email);
        });

        /*Sentry.captureEvent({
            message: 'Успешно отправленно событие добавления подписчика RetailRocket',
            environment: NODE_ENV,
            level: Sentry.Severity.Info,
            tags: {RETAILROCKET: 'add_subscription'},
            user: {email: email},
        });*/
    }

    subscriptionPopup(email)
    {
        this.track(function() {
            rrApi.setEmail(email, {EmailPopUp: true});
            rrApi.welcomeSequence(email);
        });
    }

    oneClick(productId)
    {
        this.track(function() {
            rrApi.addToBasket(productId);
        });
    }

    addToCart(product)
    {
        this.track(function() {
            rrApi.addToBasket(product.id);
        });
    }

    orderTransaction(order, basket)
    {
        let params = {
            transaction: order.id,
            items: this.formatBasket(basket)
        };
        this.track(function() {
            rrApi.order(params);
        });
    }


    productAddToFavorite(params)
    {
        this.track(function() {
            rrApi.subscribeonpricedrop(params.email, [params.product]);
        });
    }

    formatBasket(basket)
    {
        return basket.map((basketItem) => {
            return RetailRocket.formatBasketItem(basketItem);
        });
    }

    static formatBasketItem(basketItem)
    {
        return {
            id: basketItem.offer_id || basketItem.id,
            qnt: parseFloat(basketItem.quantity),
            price: parseFloat(basketItem.price)
        };
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/retailrocket.js